// src/pages/Profile/ProfileHome.js
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Package, MapPin, Users, Info, FileText, ChevronRight, Gift, ShieldAlert } from 'lucide-react';
import { triggerHaptic } from '../../utils/haptics';
import Copyright from '../../components/Copyright';
// Подключаем контекст
import { useConfig } from '../../contexts/ConfigContext';

const ProfileHome = () => {
  const navigate = useNavigate();
  // Получаем конфиг (где теперь есть правильный maxBonusPercent)
  const config = useConfig();
  
  const [balance, setBalance] = useState(0);
  
  // Берем данные из конфига
  const supportLink = config.contact?.support || "https://t.me/pixelflowai";
  const businessName = config.businessName || "MOYOO";
  
  // УДАЛЕНО: || 30. Используем значение из базы.
  const bonusPercent = config.maxBonusPercent;
  
  const tgUser = window.Telegram?.WebApp?.initDataUnsafe?.user || null;

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (!tgUser?.id) return;
        const profileRes = await axios.get(`/api/profile?user_id=${tgUser.id}`);
        setBalance(profileRes.data.balance || 0);
      } catch (e) { console.error(e); }
    };
    fetchData();
  }, [tgUser?.id]);

  const handleNavigate = (link) => { triggerHaptic('light'); navigate(link); };

  const displayName = tgUser ? `${tgUser.first_name || ''} ${tgUser.last_name || ''}`.trim() : 'Гость';
  const displayId = tgUser?.id ? `ID: ${tgUser.id}` : 'Telegram WebApp';

  return (
    <div className="min-h-screen bg-tg-bg pb-24">
      {/* HEADER */}
      <div className="px-6 pb-6 pt-tg flex items-center gap-4">
        <div className="w-16 h-16 rounded-full bg-gradient-to-tr from-blue-400 to-purple-500 flex items-center justify-center text-white text-2xl font-bold shadow-md">
          {displayName.charAt(0) || 'G'}
        </div>
        <div>
          <h1 className="text-xl font-bold text-tg-text">{displayName}</h1>
          <p className="text-tg-hint text-xs font-mono mt-1">{displayId}</p>
        </div>
      </div>
      <div className="px-4 space-y-6">
        {/* BONUS CARD */}
        <div className="w-full bg-gradient-to-r from-gray-900 to-gray-800 rounded-2xl p-5 text-white shadow-xl relative overflow-hidden">
          <div className="absolute top-0 right-0 -mt-4 -mr-4 w-24 h-24 bg-white opacity-10 rounded-full blur-xl"></div>
          <div className="flex justify-between items-start mb-6"><div><p className="text-gray-400 text-xs uppercase font-bold tracking-wider">{businessName} BONUS</p><h2 className="text-3xl font-bold mt-1">{Math.floor(balance)} Б</h2></div><Gift className="text-yellow-400" size={28} /></div>
          <div><div className="flex justify-between text-xs text-gray-300 mb-1"><span>Уровень: Новичок</span><span>PRO <span className="opacity-50">(скоро)</span></span></div><div className="w-full bg-gray-700 rounded-full h-2"><div className="bg-yellow-400 h-2 rounded-full" style={{ width: '30%' }}></div></div>
          {/* Динамический текст */}
          <p className="text-[10px] text-gray-400 mt-2">Оплачивайте бонусами до {bonusPercent}% от стоимости заказа.</p>
          </div>
        </div>
        <div>
          <h3 className="text-tg-hint text-xs uppercase font-bold mb-3 ml-1">Главное</h3>
          <div className="grid grid-cols-2 gap-3">
            <MenuCard title="Мои заказы" icon={Package} color="text-blue-500" bg="bg-blue-500/10" onClick={() => handleNavigate('/profile/orders')} />
            <MenuCard title="Адреса" icon={MapPin} color="text-green-500" bg="bg-green-500/10" onClick={() => handleNavigate('/profile/addresses')} />
            <MenuCard title="Пригласить" icon={Users} color="text-purple-500" bg="bg-purple-500/10" onClick={() => handleNavigate('/profile/invite')} />
            <MenuCard title="О нас" icon={Info} color="text-orange-500" bg="bg-orange-500/10" onClick={() => handleNavigate('/profile/info')} />
          </div>
        </div>
        <div>
          <h3 className="text-tg-hint text-xs uppercase font-bold mb-3 ml-1">Инфо</h3>
          <div className="bg-tg-secondary-bg rounded-xl overflow-hidden">
            <ListItem icon={FileText} title="Правовые документы" onClick={() => handleNavigate('/profile/documents')} />
            <div className="h-[1px] bg-tg-bg mx-12 opactiy-50"></div>
            <ListItem icon={ShieldAlert} title="Поддержка" onClick={() => window.open(supportLink, '_blank')} />
          </div>
        </div>
        <Copyright className="pb-4" />
      </div>
    </div>
  );
};

const MenuCard = ({ title, icon: Icon, color, bg, onClick }) => (<button onClick={onClick} className="bg-tg-secondary-bg p-4 rounded-2xl flex flex-col items-start gap-3 active:scale-95 transition-transform shadow-sm"><div className={`w-10 h-10 rounded-full ${bg} ${color} flex items-center justify-center`}><Icon size={20} /></div><span className="font-semibold text-tg-text text-sm">{title}</span></button>);
const ListItem = ({ icon: Icon, title, onClick }) => (<button onClick={onClick} className="w-full flex items-center justify-between p-4 active:bg-black/5 transition-colors"><div className="flex items-center gap-3"><Icon size={20} className="text-tg-hint" /><span className="text-tg-text font-medium text-sm">{title}</span></div><ChevronRight size={16} className="text-tg-hint opacity-50" /></button>);

export default ProfileHome;
